export enum PopupStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
